(function (w, $, _) {
    'use strict';

    const assetId = '~/Parts/Views/Site/ShoppingLists/ShoppingLists.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    if (w.umwAssets[assetId].length > 1) {
        console.error('More than one context was defined for ' + assetId + ', ony one is supported.');
    }

    const ctx = w.umwAssets[assetId][0];

    // ReSharper disable UndeclaredGlobalVariableUsing
    var $mainPanel = $('#' + ctx.mainPanelId);
    var $viewContainer = $mainPanel.find('.js-shoppinglists-container');
    var templateContent = ctx.templateContent;
    var labels = ctx.labels;
    var settings = ctx.settings;
    var sharedShoppingListToken = ctx.sharedShoppingListToken;
    var currentControlState = {
        controlId: ctx.controlId,
        shoppingListId: ctx.preselectedShoppingListId
    };
    // ReSharper restore UndeclaredGlobalVariableUsing

    var templateModel = {
        view: null,
        data: null,
        labels: labels,
        settings: settings
    };

    // ReSharper disable once InconsistentNaming
    var _dataCache = {};

    $(function () {
        buildView();

        // Set initial state
        w.history.replaceState(currentControlState, '', null);
        // Subscribe to popstate event
        $(w).on('popstate', onHistoryPopState);
    });

    function getShoppingListsDeferred(forceFromServer) {
        var cacheKey = 'shoppinLists';
        if (!forceFromServer && cacheKey in _dataCache) {
            return _dataCache[cacheKey];
        } else {
            var deferred = w.PublicEStore.getShoppingLists();

            _dataCache[cacheKey] = deferred;
            return deferred;
        }
    }

    function getShoppingListItemsDeferred(shoppingListId) {
        return w.PublicEStore.getShoppingList(shoppingListId);
    }

    function showShoppingListGrid() {
        blockUI();

        $.when(getShoppingListsDeferred(true))
            .done(function (shoppingListsContract) {
                var shoppingLists = shoppingListsContract.result.items;
                if (shoppingLists.length === 1) {
                    showShoppingListDetails(shoppingLists[0].id);
                } else {
                    _buildShoppingListGrid(shoppingLists);
                }
            })
            .fail(errorHandler)
            .always(unblockUI);

        function _buildShoppingListGrid(shoppingLists) {
            templateModel.view = 'grid';
            templateModel.data = shoppingLists;

            var viewHtml = _.template(templateContent, templateModel);
            var $gridFragment = $(viewHtml);
            var $shoppingListRows = $gridFragment.find('.js-shoppinglists-row');
            $shoppingListRows.each(function() {
                var $currentRow = $(this);
                var currentShoppingListId = $currentRow.data('shoppinglistid');
                var currentShoppingListDetails = _.find(shoppingLists, function(shoppingList) {
                    return shoppingList.id === currentShoppingListId;
                });

                $currentRow.data('shoppinglist', currentShoppingListDetails);
            });

            _initQuickFilter();

            _initActionButtons();

            $viewContainer.empty();
            $viewContainer.append($gridFragment);

            function _initQuickFilter() {
                var filterChangedTimeout;
                $gridFragment.find('.js-shoppinglists-quick-filter').on('keyup', function () {
                    var filterTerm = ($(this).val() || '').toLowerCase();
                    if (filterChangedTimeout) {
                        w.clearTimeout(filterChangedTimeout);
                    }

                    filterChangedTimeout = w.setTimeout(function () {
                        if (!filterTerm) {
                            $shoppingListRows.show();
                        } else {
                            $shoppingListRows.each(function () {
                                var $this = $(this);
                                var name = $this.find('.js-shoppinglist-name').text().toLowerCase();
                                var isMatch = _.some(filterTerm.split(';'), function (termPart) {
                                    termPart = $.trim(termPart);
                                    return name.indexOf(termPart) > -1;
                                });

                                $this.toggle(isMatch);
                            });
                        }
                    }, 200);
                });
            }

            function _initActionButtons() {
                $gridFragment.find('.js-action-button').click(function (evt) {
                    evt.preventDefault();

                    var $clickTarget = $(evt.target);

                    var $shoppingListRow = $clickTarget.closest('.js-shoppinglists-row');
                    var shoppingList = $shoppingListRow.data('shoppinglist');

                    var action = $clickTarget.data('action');
                    switch (action) {
                        case 'share':
                            shareShoppingList(shoppingList);
                            break;
                        case 'addtocart':
                            _addShoppingListToCart();
                            break;
                        case 'delete':
                            _handleDeleteAction();
                            break;
                        case 'showdetails':
                            _showDetails();
                            break;
                        case 'create':
                        case 'edit':
                            _createOrEditShoppingList(action);
                            break;
                    }

                    function _addShoppingListToCart() {
                        if (shoppingList.totalItems > 0) {
                            blockUI();

                            $.when(w.PublicEStore.getShoppingList(shoppingList.id))
                                .always(unblockUI)
                                .done(function (shoppingListDetailsContract) {
                                    var itemsToBuy = _.map(shoppingListDetailsContract.result.items, function (prod) {
                                        return {
                                            productId: prod.productId,
                                            name: prod.name,
                                            imageId: prod.imageID,
                                            quantity: prod.quantity,
                                            fraction: prod.fraction
                                        };
                                    });
                                    addProductsToCart(itemsToBuy);
                                })
                                .fail(errorHandler);
                        } else {
                            notify(labels.shoppingListIsEmpty, 'warning');
                        }
                    }

                    function _handleDeleteAction() {
                        deleteShoppingList(shoppingList, function () {
                            $shoppingListRow.fadeOut(300, function () { $(this).remove(); });
                        });
                    }

                    function _showDetails() {
                        showShoppingListDetails(shoppingList.id);
                        updateHistoryState(shoppingList.id);
                    }

                    function _showDetails() {
                        showShoppingListDetails(shoppingList.id);
                        updateHistoryState(shoppingList.id);
                    }

                    function _createOrEditShoppingList(action) {
                        templateModel.view = action;
                        templateModel.data = { shoppingList: shoppingList };

                        var dialogHtml = _.template(templateContent, templateModel);
                        $(dialogHtml)
                            .dialog({
                                resizable: false,
                                height: 'auto',
                                width: 400,
                                modal: true,
                                autoOpen: true,
                                buttons: {
                                    no: {
                                        text: labels.cancel,
                                        class: 'btn btn-default',
                                        click: function () {
                                            $(this).dialog('close');
                                        }
                                    },
                                    yes: {
                                        text: labels.save,
                                        autofocus: true,
                                        class: 'btn btn-primary',
                                        click: function () {
                                            const $newNameInput = $(this).find('.js-new-shoppinglist-name');
                                            const newName = $newNameInput.val();

                                            if (newName) {
                                                const newDescription = $(this).find('.js-new-shoppinglist-description').val();
                                                if (newDescription.length > 300) {
                                                    w.PubSub.publish('notification.warning', labels.shoppingListDescriptionLengthLimit);
                                                    return;
                                                }

                                                switch (action) {
                                                    case 'create':
                                                        $.when(w.PublicEStore.addShoppingList(newName, newDescription))
                                                            .done(function () {
                                                                showShoppingListGrid();
                                                            }).fail(errorHandler);
                                                        break;
                                                    case 'edit':
                                                        $.when(w.PublicEStore.updateShoppingList(shoppingList.id, newName, newDescription))
                                                            .done(function () {
                                                                shoppingList.name = newName;
                                                                shoppingList.description = newDescription;

                                                                const shoppingListNameColumn = $shoppingListRow.find('.js-shoppinglist-name')
                                                                shoppingListNameColumn.children("a").html(newName);
                                                                shoppingListNameColumn.find(".js-description").attr("title", newDescription);
                                                            }).fail(errorHandler);
                                                        break;
                                                }

                                                $(this).dialog('close');
                                            } else {
                                                w.PubSub.publish('notification.warning', labels.shoppingListNameIsEmpty);
                                            }
                                        }
                                    }
                                }
                            });
                    }
                });
            }
        }
    }

    function showShoppingListDetails(shoppingListId) {
        blockUI();

        $.when(getShoppingListsDeferred(), getShoppingListItemsDeferred(shoppingListId))
            .done(function (shoppingListsContract, shoppingListItemsContract) {
                var shoppingList = _.find(shoppingListsContract.result.items, function(item) { return item.id === shoppingListId; });

                if (!shoppingList) {
                    notify(labels.shoppingListNotFound, 'error');
                    showShoppingListGrid();
                } else {
                    var shoppingListDetails = $.extend({ items: shoppingListItemsContract.result.items }, shoppingList);
                    if (settings.autoOrdersPageUrl) {
                        var autoOrdersPageUrlWithPreselectedSlid = $.setQueryStringParam(settings.autoOrdersPageUrl, 'preselectedslid', shoppingListDetails.id);
                        shoppingListDetails.createAutoOrderUrl = $.setQueryStringParam(autoOrdersPageUrlWithPreselectedSlid, 'create', 'true');
                    }

                    _buildShoppingListDetails(shoppingListDetails);
                }
            })
            .fail(errorHandler)
            .always(unblockUI);

        function _buildShoppingListDetails(shoppingListDetails) {
            templateModel.view = 'details';
            templateModel.data = shoppingListDetails;

            var viewHtml = _.template(templateContent, templateModel);
            var $detailsFragment = $(viewHtml);

            $viewContainer.empty();
            $viewContainer.append($detailsFragment);

            var $productRows = $detailsFragment.find('.js-product-row');
            $productRows.each(function () {
                var $currentRow = $(this);
                var currentProductId = $currentRow.data('productid');
                var currentProductDetails = _.find(shoppingListDetails.items, function (product) {
                    return product.productId === currentProductId;
                });

                if (!isQuantityAllowed(currentProductDetails)) {
                    $currentRow.find('.js-quantity-not-allowed-alert').show();
                }

                $currentRow.data('product', currentProductDetails);
            });

            _initEditableTitle();
            _initSort();
            _initQuickFilter();

            if (settings.enableSorting && settings.defaultSorting && settings.defaultSorting !== '0') {
                $detailsFragment.find('.js-products-sort').trigger('change');
            }

            if (settings.enableKeyboardSupport && shoppingListDetails.items.length > 0) {
                _initKeyboardNavigation();
            }

            _initActionButtons();
            _initTotalQtyCalc();

            $detailsFragment.find('.js-environmental-fee-info').tooltip();

            function _initEditableTitle() {
                var $shoppingListTitle = $detailsFragment.find('.js-shoppinglist-details-title');
                if (shoppingListDetails.id > 0) {
                    $shoppingListTitle.keyup(function (e) {
                        if (e.keyCode == 13) {
                            $(this).blur();
                        }
                    });

                    $shoppingListTitle.change(function () {
                        var newName = this.value;
                        if (newName) {
                            blockUI();
                            $.when(w.PublicEStore.updateShoppingList(shoppingListDetails.id, newName))
                                .done(function () {
                                    shoppingListDetails.name = newName;
                                    notify(labels.shoppingListNameUpdated, 'success');
                                })
                                .fail(errorHandler)
                                .always(unblockUI);
                        } else {
                            notify(labels.shoppingListNameIsEmpty, 'warning');
                        }
                    });
                } else {
                    $shoppingListTitle.prop('disabled', true);
                }

                $detailsFragment.find('.js-click-to-edit-shoppinglist-title-button').click(function() {
                    $shoppingListTitle.focus();
                });
            }

            function _initSort() {
                $detailsFragment.find('.js-products-sort').change(function () {
                    var sort = $(this).val().toLowerCase();
                    var $rows = $detailsFragment.find('.js-product-row');
                    var $cont = $rows.first().parent();
                    var comparer, gt;

                    switch (sort) {
                        case 'name asc':
                        case 'name desc':
                            gt = sort == 'name desc' ? -1 : 1;
                            comparer = function (r1, r2) { return strcmp($(r1).find('.js-product-name').text(), $(r2).find('.js-product-name').text(), gt); };
                            break;
                        case 'productno asc':
                        case 'productno desc':
                            gt = sort == 'productno desc' ? -1 : 1;
                            comparer = function (r1, r2) { return strcmp($(r1).find('.js-product-no').text(), $(r2).find('.js-product-no').text(), gt); };
                            break;
                        default:
                            gt = 1;
                            comparer = function (r1, r2) { return intcmp($(r1).data('index'), $(r2).data('index'), gt); };
                            break;
                    }
                    $rows.sort(comparer);
                    $rows.detach().appendTo($cont);
                });
                function strcmp(str1, str2, gt) { return str1 > str2 ? gt : (str1 < str2 ? -gt : 0); };
                function intcmp(int1, int2, gt) { return int1 > int2 ? gt : (int1 < int2 ? -gt : 0); };
            };
            function _initQuickFilter() {
                var filterChangedTimeout;
                $detailsFragment.find('.js-products-quick-filter').on('keyup', function () {
                    var filterTerm = ($(this).val() || '').toLowerCase();
                    if (filterChangedTimeout) {
                        w.clearTimeout(filterChangedTimeout);
                    }
                    filterChangedTimeout = w.setTimeout(function () {
                        if (!filterTerm) {
                            $productRows.show();
                        } else {
                            var splitFilterTerm = filterTerm.split(';');
                            var $correspondingRows = $productRows.filter(function () {
                                var $this = $(this);
                                var prodNo = $this.find('.js-product-name').text().toLowerCase();
                                var prodName = $this.find('.js-product-no').text().toLowerCase();
                                return _.some(splitFilterTerm, function (termPart) {
                                    termPart = $.trim(termPart);
                                    return prodNo.indexOf(termPart) > -1 || prodName.indexOf(termPart) > -1;
                                });
                            });
                            var $notCorrespondingRows = $productRows.not($correspondingRows);
                            $correspondingRows.show();
                            $notCorrespondingRows.hide();
                        }
                    }, 200);
                });
            }

            function _initKeyboardNavigation() {
                var mousedownTarget;
                $productRows.mousedown(function (e) {
                    mousedownTarget = e.target;
                });

                $productRows.click(function () {
                    var $this = $(this);
                    var $target = $(mousedownTarget);
                    _setCurrentRow($this, $target);
                });

                $(document).keydown(function (evt) {
                    var $target = $(evt.target);
                    if (($target.prop('tagName').toLowerCase() !== 'input' && $target.prop('tagName').toLowerCase() !== 'textarea') ||
                        $target.hasClass('js-product-in-shoppinglist-quantity') || $target.hasClass('js-product-in-shoppinglist-fraction')) {
                        switch (evt.which) {
                            case 38:    // Up arrow
                                evt.preventDefault();
                                _moveCursorToPrevRow();
                                break;
                            case 40:    // Down arrow
                                evt.preventDefault();
                                _moveCursorToNextRow();
                                break;
                            case 39:    // Righ arrow
                            case 61:    // + sign
                            case 107:   // + sign
                                evt.preventDefault();
                                if ($target.hasClass('js-product-in-shoppinglist-fraction')) {
                                    _changeProductFraction(1);
                                } else {
                                    _changeProductQuantity(1);
                                }
                                break;
                            case 37:    // Left arrow
                            case 173:   // - sign
                            case 109:   // - sign
                                evt.preventDefault();
                                if ($target.hasClass('js-product-in-shoppinglist-fraction')) {
                                    _changeProductFraction(-1);
                                } else {
                                    _changeProductQuantity(-1);
                                }
                                break;
                            case 13:    // Enter
                                evt.preventDefault();
                                _addProductToCart();
                                break;
                        }
                    }
                });

                function _moveCursorToNextRow() {
                    var $currentRow = _getCurrentRow();
                    var $nextRow;
                    if ($currentRow.length > 0) {
                        $nextRow = $currentRow.next();
                        if ($nextRow.length === 0) {
                            $nextRow = $productRows.first();
                        }
                    } else {
                        $nextRow = $productRows.first();
                    }

                    _setCurrentRow($nextRow);
                    _scrollToCenter($nextRow);
                }
                function _moveCursorToPrevRow() {
                    var $currentRow = _getCurrentRow();
                    var $previousRow;
                    if ($currentRow.length > 0) {
                        $previousRow = $currentRow.prev();
                        if ($previousRow.length === 0) {
                            $previousRow = $productRows.last();
                        }
                    } else {
                        $previousRow = $productRows.last();
                    }

                    _setCurrentRow($previousRow);
                    _scrollToCenter($previousRow);
                }
                function _changeProductQuantity(difference) {
                    var $currentRow = _getCurrentRow();
                    if ($currentRow.length > 0) {
                        var $quantityInput = $currentRow.find('.js-product-in-shoppinglist-quantity');
                        if ($quantityInput.prop('tagName').toLowerCase() === 'input') {
                            var newValue = getQuantityInputValue($quantityInput) + difference;
                            $quantityInput.val(newValue > 0 ? newValue : 0);
                        }
                    }
                }
                function _changeProductFraction(difference) {
                    var $currentRow = _getCurrentRow();
                    if ($currentRow.length > 0) {
                        var $fractionInput = $currentRow.find('.js-product-in-shoppinglist-fraction');
                        var newValue = getFractionInputValue($fractionInput) + difference;
                        $fractionInput.val(newValue > 0 ? newValue : 0);
                    }
                }
                function _addProductToCart() {
                    var $currentRow = _getCurrentRow();

                    var toAdd = getAddToCartProductContracts($currentRow);
                    if (toAdd.length > 0) {
                        addProductsToCart(toAdd);
                    } else {
                        notify(labels.nothingToAdd, 'warning');
                    }
                }

                function _getCurrentRow() {
                    return $productRows.filter('.js-keyboard-nav-cursor');
                }
                function _setCurrentRow($row, $target) {
                    $productRows.removeClass('js-keyboard-nav-cursor');
                    $row.addClass('js-keyboard-nav-cursor');

                    if (!$target || !$target.hasClass('js-product-in-shoppinglist-fraction')) {
                        $row.find('.js-product-in-shoppinglist-quantity').select();
                    } 
                }
                function _scrollToCenter($row) {
                    // Scroll cursor row to the middle of the screen
                    var elOffset = $row.offset().top;
                    var elHeight = $row.height();
                    var windowHeight = $(window).height();

                    var offset;
                    if (elHeight < windowHeight) {
                        offset = elOffset - ((windowHeight / 2) - (elHeight / 2));
                    }
                    else {
                        offset = elOffset;
                    }

                    var speed = 300;
                    $('html, body').animate({ scrollTop: offset }, speed);
                }
            }

            function _initActionButtons() {
                $detailsFragment.find('.js-action-button')
                    .click(function(evt) {
                        evt.preventDefault();

                        var $clickTarget = $(evt.target);
                        var action = $clickTarget.data('action');
                        switch (action) {
                            case 'share':
                                shareShoppingList(shoppingListDetails);
                                break;
                            case 'addvisibleproductstocart':
                                _handleAddVisibleShoppingListProductsToCart();
                                break;
                            case 'deleteshoppinglist':
                                _handleShoppingListDelete();
                                break;
                            case 'addproducttocart':
                                _handleAddProductToCart();
                                break;
                            case 'deleteproductfromshoppinglist':
                                _handleDeleteProductFromShoppingList();
                                break;
                            case 'focustitleedit':
                                _handleFocusTitleEdit();
                                break;
                            case 'updateproductquantity':
                                _handleUpdateProductQuantity();
                                break;
                            case 'updateproductdescription':
                                _handleUpdateProductDescription();
                                break;
                            case 'exporttoexcel':
                                _exportToExcel();
                                break;
                        }

                        function _handleAddVisibleShoppingListProductsToCart() {
                            var toAdd = getAddToCartProductContracts($productRows.filter(':visible'));
                            if (toAdd.length > 0) {
                                addProductsToCart(toAdd);
                            } else {
                                notify(labels.nothingToAdd, 'warning');
                            }
                        }

                        function _handleShoppingListDelete() {
                            deleteShoppingList(shoppingListDetails, function() {
                                    showShoppingListGrid();
                                    updateHistoryState(null, true);
                                });
                        }

                        function _handleAddProductToCart() {
                            var $productRow = $clickTarget.closest('.js-product-row');
                            var toAdd = getAddToCartProductContracts($productRow);
                            if (toAdd.length > 0) {
                                addProductsToCart(toAdd);
                            } else {
                                notify(labels.nothingToAdd, 'warning');
                            }
                        }

                        function _handleDeleteProductFromShoppingList() {
                            var $productRow = $clickTarget.closest('.js-product-row');
                            var product = $productRow.data('product');

                            var confirmationTitle = labels.deleteProductFromShoppingListConfirmationTitle;
                            var confirmationText = labels.deleteProductFromShoppingListConfirmation.replace('SHOPPING_LIST_NAME', shoppingListDetails.name).replace('PRODUCT_NAME', product.name);
                            showConfirmation(confirmationTitle, confirmationText, function() {
                                    blockUI();
                                    $.when(w.PublicEStore.removeFromShoppingList(shoppingListDetails.id, product.productId))
                                        .done(function() {
                                            $productRow.fadeOut(300, function() {
                                                $(this).remove();
                                                if ($detailsFragment.find('.js-product-row').length === 0)
                                                    $viewContainer.find('.js-hide-when-list-empty').hide();
                                            });
                                            notify(labels.productRemovedFromShoppingList.replace('PRODUCT_NAME', product.name).replace('SHOPPING_LIST_NAME', shoppingListDetails.name), 'success');
                                        })
                                        .fail(errorHandler)
                                        .always(unblockUI);
                                });
                        }

                        function _handleFocusTitleEdit() {
                            $detailsFragment.find('.js-shoppinglist-details-title').select();
                        }

                        function _handleUpdateProductQuantity() {
                            var $productRow = $clickTarget.closest('.js-product-row');
                            var shoppingListItem = $productRow.data('product');
                            var newQuantity = getQuantityInputValue($productRow);
                            var newFraction = getFractionInputValue($productRow);

                            if (newQuantity > 0 || newFraction > 0) {
                                blockUI();
                                var itemToUpdate = { shoppingListItemId: shoppingListItem.id, itemId: shoppingListItem.itemId, quantity: newQuantity, fraction: newFraction };
                                $.when(w.PublicEStore.updateShoppingListItemsQuantity(itemToUpdate))
                                    .always(unblockUI)
                                    .done(function() {
                                        $productRow.effect('highlight', { color: '#DAF7A6' });

                                        if (!isQuantityAllowed(shoppingListItem)) {
                                            $productRow.find('.js-quantity-not-allowed-alert').hide();
                                        }

                                        notify(labels.productQuantityUpdated.replace('PRODUCT_NAME', shoppingListItem.name), 'success');
                                    })
                                    .fail(function() {
                                        notify(labels.failedToUpdateProductQuantity .replace('PRODUCT_NAME', shoppingListItem.name), 'error');
                                    });
                            } else {
                                notify(labels.quantityShouldBeGreaterThanZero, 'warning');
                            }
                        }


                        function _handleUpdateProductDescription() {
                            var $productRow = $clickTarget.closest('.js-product-row');
                            var shoppingListItem = $productRow.data('product');

                            templateModel.view = 'editItem';
                            templateModel.data = { shoppingListItem: shoppingListItem };

                            var dialogHtml = _.template(templateContent, templateModel);
                            $(dialogHtml)
                                .dialog({
                                    resizable: false,
                                    height: 'auto',
                                    width: 400,
                                    modal: true,
                                    autoOpen: true,
                                    buttons: {
                                        no: {
                                            text: labels.cancel,
                                            class: 'btn btn-default',
                                            click: function () {
                                                $(this).dialog('close');
                                            }
                                        },
                                        yes: {
                                            text: labels.save,
                                            autofocus: true,
                                            class: 'btn btn-primary',
                                            click: function () {
                                                const newDescription = $(this).find('.js-new-shoppinglist-item-description').val();
                                                if (newDescription.length > 300) {
                                                    w.PubSub.publish('notification.warning', labels.shoppingListDescriptionLengthLimit);
                                                    return;
                                                }

                                                var itemToUpdate = { shoppingListItemId: shoppingListItem.id, itemId: shoppingListItem.itemId, description: newDescription};
                                                $.when(w.PublicEStore.updateShoppingListItemsDescription(itemToUpdate))
                                                    .done(function () {
                                                        shoppingListItem.description = newDescription;
                                                        $productRow.find('.js-description').attr("title", newDescription);
                                                    })
                                                    .fail(errorHandler);

                                              
                                                $(this).dialog('close');
                                            }
                                        }
                                    }
                                });
                        }

                        function _exportToExcel() {
                            if (settings.exportToExcelUrlTemplate) {
                                window.location = settings.exportToExcelUrlTemplate.replace('{0}', shoppingListDetails.id);
                            }
                        }
                    });
            }

            function _initTotalQtyCalc() {
                $detailsFragment.find('.js-product-in-shoppinglist-quantity, .js-product-in-shoppinglist-fraction').on('keyup change paste input', function() {
                    var $row = $(this).closest('.js-product-row');
                    var prod = $row.data('product');
                    var $totalQty = $row.find('.js-product-in-shoppinglist-total-qty');
                    if (prod && prod.factor && $totalQty.length) {
                        var qty = getQuantityInputValue($row);
                        var fraction = getFractionInputValue($row) || 0;
                        var totalQty = qty * prod.factor + fraction;
                        $totalQty.text(totalQty);
                    }
                });
            }
        }
    }

    function showSharedShoppingListDetails(token) {
        blockUI();

        $.ajax({
                url: w.R + 'handlers/public/estoredata.ashx',
                type: 'GET',
                data: {
                    action: 'GetSharedShoppingListDetails',
                    token: token,
                },
            })
            .always(unblockUI)
            .done(_buildSharedShoppingListDetails)
            .fail(errorHandler);

        function _buildSharedShoppingListDetails(sharedShoppingListDetails) {
            templateModel.view = 'shareddetails';
            templateModel.data = sharedShoppingListDetails;

            var viewHtml = _.template(templateContent, templateModel);
            var $detailsFragment = $(viewHtml);

            $viewContainer.empty();
            $viewContainer.append($detailsFragment);

            var $productRows = $detailsFragment.find('.js-product-row');
            $productRows.each(function () {
                var $currentRow = $(this);
                var currentProductId = $currentRow.data('productid');
                var currentProductDetails = _.find(sharedShoppingListDetails.items, function (product) {
                    return product.productId === currentProductId;
                });

                $currentRow.data('product', currentProductDetails);
            });

            _initActionButtons();

            $detailsFragment.find('.js-environmental-fee-info').tooltip();

            var immediatelySaveSharedShoppingList = window.getFromLocalStorage('save_shared_shopping_list') === 'true';
            if (immediatelySaveSharedShoppingList) {
                window.removeFromLocalStorage('save_shared_shopping_list');

                _handleSaveSharedShoppingList(false);
            }

            function _handleSaveSharedShoppingList(redirectToLoginIfUnathorized) {
                blockUI();

                var toAdd = getAddToCartProductContracts($productRows.filter(':visible'));
                var sharedShoppingListName = $detailsFragment.find('.js-shoppinglist-details-title').val();
                $.when(w.PublicEStore.addShoppingList(sharedShoppingListName, '', toAdd))
                    .always(function (dataContract) {
                        unblockUI();

                        // Status for every product
                        if (dataContract.result && dataContract.result.items) {
                            _.each(dataContract.result.items, function (prod) {
                                var productStatus = prod.status.toLowerCase();
                                var shoppingListProduct = _.find(toAdd, function (item) { return item.productId === prod.productID; });
                                var productMessage = '"' + shoppingListProduct.name + '": ' + prod.message;
                                if (productStatus === 'warning') {
                                    notify(productMessage, 'warning');
                                } else if (productStatus === 'error') {
                                    notify(productMessage, 'error');
                                }
                            });
                        }

                        // Status for the whole action
                        var actionStatus = dataContract.status.toLowerCase();
                        switch (actionStatus) {
                            case 'ok':
                                notify(labels.sharedShoppingListSaved.replace('SHOPPING_LIST_NAME', dataContract.result.name), 'success');
                                _redirectToGridView();
                                break;
                            case 'warning':
                                notify(dataContract.message, 'warning');
                                _redirectToGridView();
                                break;
                            case 'error':
                                notify(dataContract.message, 'error');
                                break;
                            case 'unauthorized':
                                if (redirectToLoginIfUnathorized) {
                                    _redirectToLoginPage();
                                }
                                break;
                        }

                        function _redirectToGridView() {
                            showShoppingListGrid();
                            updateHistoryState(null, true);
                        }

                        function _redirectToLoginPage() {
                            window.saveToLocalStorage('save_shared_shopping_list', 'true');
                            window.location.replace(settings.loginUrl);
                        }
                    });
            }

            function _initActionButtons() {
                $detailsFragment.find('.js-action-button')
                    .click(function (evt) {
                        evt.preventDefault();

                        var $clickTarget = $(evt.target);
                        var action = $clickTarget.data('action');
                        switch (action) {
                            case 'savesharedshoppinglist':
                                _handleSaveSharedShoppingList(true);
                                break;
                            case 'addvisibleproductstocart':
                                _handleAddVisibleProductsToCart();
                                break;
                            case 'addproducttocart':
                                _handleAddProductToCart();
                                break;
                            case 'deleteproductfromsharedshoppinglist':
                                _handleDeleteProductFromSharedShoppingList();
                                break;
                        }

                        function _handleAddVisibleProductsToCart() {
                            var toAdd = getAddToCartProductContracts($productRows.filter(':visible'));
                            if (toAdd.length > 0) {
                                addProductsToCart(toAdd);
                            } else {
                                notify(labels.nothingToAdd, 'warning');
                            }
                        }

                        function _handleAddProductToCart() {
                            var $productRow = $clickTarget.closest('.js-product-row');
                            var toAdd = getAddToCartProductContracts($productRow);
                            if (toAdd.length > 0) {
                                addProductsToCart(toAdd);
                            } else {
                                notify(labels.nothingToAdd, 'warning');
                            }
                        }

                        function _handleDeleteProductFromSharedShoppingList() {
                            var $productRow = $clickTarget.closest('.js-product-row');
                            var product = $productRow.data('product');

                            var confirmationTitle = labels.deleteProductFromShoppingListConfirmationTitle;
                            var confirmationText = labels.deleteProductFromShoppingListConfirmation.replace('SHOPPING_LIST_NAME', labels.sharedShoppingList).replace('PRODUCT_NAME', product.name);
                            showConfirmation(confirmationTitle, confirmationText, function () {
                                $productRow.fadeOut(300, function () { $(this).remove(); });
                            });
                        }
                    });
            }
        }
    }

    function getAddToCartProductContracts($productRows) {
        var contracts = $productRows.map(function (index, productRow) {
            var $row = $(productRow);
            var prod = $row.data('product');
            var qty = getQuantityInputValue($row);
            var fraction = getFractionInputValue($row);
            return prod.available && (qty > 0 || fraction > 0)
                ? {
                    productId: prod.productId,
                    name: prod.name,
                    imageId: prod.imageID,
                    quantity: qty,
                    fraction: fraction
                }
                : null;
        }).get();

        return contracts;
    }

    function addProductsToCart(itemsToAdd) {
        if (itemsToAdd && itemsToAdd.length > 0) {
            blockUI();

            $.when(w.PublicEStore.addToCart(itemsToAdd))
                .always(function (dataContract) {
                    unblockUI();

                    // Status for every product
                    _.each(dataContract.result.items, function (prod) {
                        var productStatus = prod.status.toLowerCase();
                        var shoppingListProduct = _.find(itemsToAdd, function (item) { return item.productId === prod.productID; });
                        var productMessage = '"' + shoppingListProduct.name + '": ' + prod.message;
                        if (productStatus === 'warning') {
                            notify(productMessage, 'warning');
                        } else if (productStatus === 'error') {
                            notify(productMessage, 'error');
                        }
                    });

                    // Status for the whole action
                    var actionStatus = dataContract.status.toLowerCase();
                    switch(actionStatus) {
                        case 'ok':
                            notify(labels.addedToCart, 'success');
                            break;
                        case 'warning':
                            notify(dataContract.message, 'warning');
                            break;
                        case 'error':
                            notify(dataContract.message, 'error');
                            break;
                    }
                });
        } else {
            notify(labels.nothingToAdd, 'warning');
        }
    }

    function shareShoppingList(shoppingList) {
        if (shoppingList.totalItems > 0) {
            templateModel.view = 'share';
            templateModel.data = { shoppingList: shoppingList };

            var shareDialogHtml = _.template(templateContent, templateModel);
            $(shareDialogHtml)
                .dialog({
                    resizable: false,
                    height: 'auto',
                    width: 400,
                    modal: true,
                    autoOpen: true,
                    open: function () {
                        var $shareDialog = $(this);
                        const $shareByEmailInput = $shareDialog.find('.js-share-shoppinglist-recipient-email-input');
                        const $shareByEmailButton = $shareDialog.find('.js-send-sharing-invitation-by-email-button');

                        $shareDialog.find('button[data-target="#shareShoppinglistDialogSendEmail"]').on('click', () => { w.recaptcha_load(); });

                        let captchaWidgetId = null;

                        w.PubSub.subscribe('recaptcha.callback.loaded', function () {
                            captchaWidgetId = w.grecaptcha.render('divRecaptcha2', {
                                'sitekey': ctx.settings.recaptcha2SiteKey,
                                'theme': ctx.settings.recaptchaTheme,
                                'size': ctx.settings.recaptchaSize
                            });
                        });
                        
                        $shareDialog.find('.js-share-url-input').select();

                        $shareByEmailButton.click(function (evt) {
                            evt.preventDefault();
                            sendByEmail();
                        });

                        $shareByEmailInput.keyup(function (e) {
                            if (e.keyCode === 13) {
                                sendByEmail();
                            }
                        });

                        function sendByEmail() {
                            const recipientEmail = $shareByEmailInput.val();
                            const comment = $shareDialog.find('.js-share-shoppinglist-email-message').val();

                            const captchaResponse = w.grecaptcha.getResponse(captchaWidgetId);
                            _sendSharingInvitationByEmail(shoppingList.id, recipientEmail, captchaResponse, comment);
                        }
                    },
                    close: function() {
                        $(this).dialog('destroy').remove();
                    },
                });
        } else {
            notify(labels.shoppingListIsEmpty, 'warning');
        }

        function _sendSharingInvitationByEmail(shoppingListId, recipientEmail, captchaResponse, comment) {
            if (!recipientEmail) {
                notify(labels.incorrectRecipientEmail, 'warning');
            } else {
                blockUI();

                $.ajax({
                    url: w.R + 'handlers/public/estoredata.ashx',
                    type: 'POST',
                    data: {
                        action: 'ShareShoppingList',
                        recipientEmail: recipientEmail,
                        comment : comment,
                        shoppingListID: shoppingListId,
                        fromAddress: settings.shareEmailFromAddress,
                        friendlyFrom: settings.shareEmailFriendlyFrom,
                        subject: settings.shareEmailSubject,
                        templateID: settings.shareEmailMessageTemplateID,
                        captchaResponse: captchaResponse
                    },
                })
                    .done(function () {
                        notify(labels.sharingInvitationIsSent, 'success');
                        w.grecaptcha.reset();
                    })
                    .fail(errorHandler)
                    .always(unblockUI);
            }
        }
    }

    function deleteShoppingList(shoppingList, deletedCallback) {
        showConfirmation(labels.deleteShoppingListConfirmationTitle.replace('SHOPPING_LIST_NAME', shoppingList.name), labels.deleteShoppingListConfirmation.replace('SHOPPING_LIST_NAME', shoppingList.name), function () {
            blockUI();

            $.when(w.PublicEStore.removeShoppingList(shoppingList.id))
                .done(function () {
                    notify(labels.shoppingListDeleted.replace('SHOPPING_LIST_NAME', shoppingList.name), 'success');
                    if (typeof (deletedCallback) === 'function') {
                        deletedCallback.apply(this, [shoppingList]);
                    }
                })
                .fail(errorHandler)
                .always(unblockUI);
        });
    }

    // #region History state handling
    function updateHistoryState(shoppingListId, replace) {
        currentControlState.shoppingListId = shoppingListId;

        if (w.history && typeof (w.history.pushState) !== 'undefined') {
            var newStateUrl = location.href;

            if (isValidShoppingListId(currentControlState.shoppingListId)) {
                newStateUrl = $.setQueryStringParam(newStateUrl, 'slid', currentControlState.shoppingListId);
            } else {
                newStateUrl = $.removeQueryStringParam(newStateUrl, 'slid');
            }

            newStateUrl = $.removeQueryStringParam(newStateUrl, 'shareList');

            if (newStateUrl != location.href) {
                replace ? w.history.replaceState(currentControlState, '', newStateUrl) : w.history.pushState(currentControlState, '', newStateUrl);
            }
        }
    }

    function onHistoryPopState(evt) {
        var state = evt.originalEvent.state;
        if (state && state.controlId == currentControlState.controlId) {
            currentControlState = state;

            buildView();
        }
    }

    function buildView() {
        if (isValidShoppingListId(currentControlState.shoppingListId)) {
            showShoppingListDetails(currentControlState.shoppingListId);
        } else if (sharedShoppingListToken) {
            showSharedShoppingListDetails(sharedShoppingListToken);
        } else {
            showShoppingListGrid();
        }
    }

    function isValidShoppingListId(shoppingListId) {
        return typeof (shoppingListId) === 'number' && shoppingListId >= 0;
    }

    // #endregion History state handling

    // #region Helpers
    function getQuantityInputValue($inputElem) {
        var $quantityInput = $inputElem.hasClass('js-product-in-shoppinglist-quantity') ? $inputElem : $inputElem.find('.js-product-in-shoppinglist-quantity');
        var quantityStringValue = $quantityInput.val();
        return parseFloat(quantityStringValue.replace(',', '.')) || 0;
    }

    function getFractionInputValue($inputElem) {
        var $fractionInput = $inputElem.hasClass('js-product-in-shoppinglist-fraction') ? $inputElem : $inputElem.find('.js-product-in-shoppinglist-fraction');
        return $fractionInput.length ? $.mw_tryParseFloatStrict($fractionInput.val()) : NaN;
    }

    function isQuantityAllowed(item) {
        return !item.allowedQuantities || item.allowedQuantities.length === 0 || _.some(item.allowedQuantities, function(allowedQuantity) {
            return allowedQuantity.raw === item.quantity;
        });
    }

    function notify(message, type) {
        var notificationChannel = typeof (type) === 'string' && type ? 'notification.' + type : 'notification';
        w.PubSub.publish(notificationChannel, message);
    }
    function blockUI() {
        if (typeof ($.blockUI) === 'function') {
            $mainPanel.block({ message: null });
        }
    }
    function unblockUI() {
        if (typeof ($.unblockUI) === 'function') {
            $mainPanel.unblock();
        }
    }
    function errorHandler(error) {
        unblockUI();

        var message;

        if (typeof (error) === 'string') {
            message = error;
        } else {
            message = typeof (error) !== 'undefined' ? (error.message ? error.message : error.statusText) : 'Unknow error';
        }

        notify(message, 'error');
    }
    function showConfirmation(confirmationTitle, confirmationText, confirmedCallback, declinedCallback) {
        $('<div class=\"confirmation-text\">' + confirmationText + '</div>')
            .dialog({
                title: confirmationTitle || labels.defaultConfirmationTitle,
                resizable: false,
                height: 'auto',
                width: 450,
                modal: true,
                autoOpen: true,
                buttons: [
                    {
                        'class': 'btn btn-default',
                        text: labels.yes,
                        click: function() {
                            $(this).dialog('close');

                            if (typeof (confirmedCallback) === 'function') {
                                confirmedCallback.call(this);
                            }
                        }
                    },
                    {
                        'class': 'btn btn-default',
                        text: labels.no,
                        click: function() {
                            $(this).dialog('close');

                            if (typeof (declinedCallback) === 'function') {
                                declinedCallback.call(this);
                            }
                        }
                    }
                ],
                close: function () {
                    $(this).dialog('destroy').remove();
                },
            });
    }
    // #endregion Helpers
})(window, jQuery, _);